// extracted by mini-css-extract-plugin
export var button = "ButtonBorder-module--button--TGcir";
export var lightTheme = "ButtonBorder-module--lightTheme--QHWFT";
export var text = "ButtonBorder-module--text--z-Fg5";